import * as THREE from 'three';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js';
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader.js';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      const mm = gsap.matchMedia();
      $( '.open-reveal-scroll' ).each( function( key, component ) {
        const leftImage = $( this ).find( '.open-reveal-scroll__image--left' )[0];
        const rightImage = $( this ).find( '.open-reveal-scroll__image--right' )[0];
        const fake = $( this ).find( '.open-reveal-scroll__fake' )[0];
        const componentHeight = $( this ).outerHeight();
        let topOffset = $( '.navbar' ).outerHeight();

        if ( $( '#wpadminbar' ).length ) {
          topOffset += $( '#wpadminbar' ).outerHeight();
        }

        if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
          mm.add( '(min-width: 1024px)', () => {
            const tl = gsap.timeline( {
              scrollTrigger: {
                pin: component,
                trigger: this,
                start: 'top ' + topOffset,
                end: 'bottom top',
                scrub: 1,
              },
            } );

            tl.to( leftImage, {x: '-100%', ease: 'linear', delay: 0, duration: 0.5}, 0 );
            tl.to( rightImage, {x: '100%', ease: 'linear', delay: 0, duration: 0.5}, 0 );
          } );

          mm.add( '(max-width: 1023px)', () => {
            const tl = gsap.timeline( {
              scrollTrigger: {
                pin: component,
                trigger: this,
                start: 'top ' + topOffset,
                end: 'bottom -200%',
                scrub: 1,
              },
            } );

            tl.to( leftImage, {y: '-100%', ease: 'linear', delay: 0, duration: 0.25}, 0 );
            tl.to( rightImage, {y: '-100%', ease: 'linear', delay: 0.25, duration: 0.25}, 0 );
            tl.to( fake, {opacity: 0, ease: 'linear', delay: 0.5, duration: 0.25}, 0 );
          } );
        }

        const modelSrc = $( component ).find( '.open-reveal-scroll__model' ).attr( 'data-src' );

        if ( !modelSrc ) {
          return;
        }

        // --- Scene Setup ---
        const scene = new THREE.Scene();
        const canvas = $( component ).find( 'canvas' )[0];
        const container = canvas.parentElement;
        const width = container.clientWidth;
        const height = container.clientHeight;

        const camera = new THREE.PerspectiveCamera( 45, width / height, 0.1, 100 );

        const renderer = new THREE.WebGLRenderer( {
          canvas: canvas,
          antialias: true,
          alpha: true,
        } );
        renderer.setSize( width, height );
        renderer.setPixelRatio( window.devicePixelRatio );

        // --- Lighting ---
        const ambientLight = new THREE.AmbientLight( 0xffffff, 1 );
        scene.add( ambientLight );

        const directionalLight = new THREE.DirectionalLight( 0xffffff, 2 );
        directionalLight.position.set( 5, 5, 5 );
        scene.add( directionalLight );

        // --- Load GLB ---
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath( '/wp-content/themes/mastersmotors/resources/js/draco/' );
        const loader = new GLTFLoader();
        loader.setDRACOLoader( dracoLoader );
        let model;

        loader.load(
            modelSrc,
            ( gltf ) => {
              model = gltf.scene;
              scene.add( model );

              // Center the model
              const box = new THREE.Box3().setFromObject( model );
              const size = box.getSize( new THREE.Vector3() );
              const center = box.getCenter( new THREE.Vector3() );
              model.position.sub( center );

              // Fit camera to model
              const maxDim = Math.sqrt( size.x ** 2 + size.y ** 2 + size.z ** 2 );
              const fov = camera.fov * ( Math.PI / 180 );
              const distance = ( maxDim / 2 ) / Math.tan( fov / 2 );
              camera.position.set( 0, 0, distance * 1.2 );
              camera.updateProjectionMatrix();

              setupScrollAnimation();
            },
            ( xhr ) => null,
            ( error ) => console.error( 'GLB load error:', error ),
        );

        // --- GSAP Scroll Rotation ---
        function setupScrollAnimation() {
          if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
            mm.add( '(min-width: 1024px)', () => {
              gsap.to( model.rotation, {
                y: Math.PI * 2,
                ease: 'none',
                scrollTrigger: {
                  trigger: component,
                  start: 'top 50%',
                  end: 'bottom -50%',
                  scrub: 1,
                },
              } );
            } );

            mm.add( '(max-width: 1023px)', () => {
              gsap.to( model.rotation, {
                y: Math.PI * 2,
                ease: 'none',
                scrollTrigger: {
                  trigger: component,
                  start: 'top 50%',
                  end: 'bottom -250%',
                  scrub: 1,
                },
              } );
            } );
          }
        }

        // --- Render Loop ---
        function animate() {
          requestAnimationFrame( animate );
          renderer.render( scene, camera );
        }
        animate();

        // --- Handle Resize ---
        window.addEventListener( 'resize', () => {
          const w = container.clientWidth;
          const h = container.clientHeight;
          camera.aspect = w / h;
          camera.updateProjectionMatrix();
          renderer.setSize( w, h );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'open-reveal-scroll', COMPONENT );
} )( app );
